import { useState } from 'react';
import getWindowWidth from '@/utilites/get-window-width';
import useMonitorWindowWidth from './useMonitorWindowWidth';

function useWindowWidth(windowWidthSv: number | null = null): number {
  const [windowWidth, setWindowWidth] = useState(0);

  useMonitorWindowWidth(setWindowWidth);

  return getWindowWidth(windowWidth, windowWidthSv);
}

export default useWindowWidth;
